"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PulseUrlChangedEvent {
    constructor(oldUrl, newUrl, context) {
        this._oldUrl = oldUrl;
        this._newUrl = newUrl;
        this._context = context;
    }
    get oldUrl() {
        return this._oldUrl;
    }
    get newUrl() {
        return this._newUrl;
    }
    get context() {
        return this._context;
    }
}
exports.PulseUrlChangedEvent = PulseUrlChangedEvent;
//# sourceMappingURL=PulseUrlChangedEvent.js.map